var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.prototype.getFullName = function (user) {
        // TODO: find the root cause of the problem
        if (!user)
            return;
        return user.name ? user.name + " " + user.surname : user.username;
    };
    default_1.prototype.isActive = function (user) {
        // TODO: find the root cause of the problem
        if (!user)
            return;
        return user.state === 'ACTIVE';
    };
    return default_1;
}());
export default default_1;
